<template>
  <v-btn
    class="ma-1 font-weight-regular base-button"
    :class="textClass"
    :color="customColor"
    elevation="0"
    :min-width="customWidth"
    :height="customHeight"
    size="large"
    :to="toPath"
    v-bind="$attrs"
    :disabled="disabled"
    :style="'font-size: ' + customFontSize + ';'"
    :variant="customVariant"
    :loading="customLoading"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  emits: ["click"],
  computed: {
    textClass() {
      // Outlined/text buttons should inherit their text color from Vuetify,
      // but elevated/flat variants need white text on colored backgrounds.
      const v = String(this.customVariant || "").toLowerCase();
      const isOutlined = v === "outlined" || v === "text" || v === "plain";
      return isOutlined ? "" : "text-white";
    },
  },
  props: {
    toPath: {
      type: [String, Object],
      required: false,
    },
    customColor: {
      type: String,
      required: false,
      default: "button",
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    customWidth: {
      type: String,
      required: false,
      default: "100px",
    },
    customHeight: {
      type: String,
      required: false,
      default: "40px",
    },
    customFontSize: {
      type: String,
      required: false,
      default: "14px",
    },
    customVariant: {
      type: String,
      required: false,
      default: "elevated",
    },
    customLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped>
.base-button {
  border-radius: 16px;
  font-weight: 450;
}
</style>
